import { env } from "@/lib/env";
import { cn } from "@/lib/utils";

/** The Quick Planning Poker mark: two fanned cards, the front one with a lightning bolt. */
export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={cn("size-6 shrink-0", className)}>
      <rect
        x="4.5"
        y="6.5"
        width="15"
        height="21"
        rx="2.75"
        transform="rotate(-14 12 17)"
        strokeWidth="1.25"
        className="fill-primary/30 stroke-primary"
      />
      <g transform="rotate(7 19 15.25)">
        <rect
          x="11"
          y="4"
          width="16"
          height="22.5"
          rx="3"
          strokeWidth="1.5"
          className="fill-primary stroke-background"
        />
        <path
          d="M20.6 8.6 14.9 16.9h3.7l-1.3 6.3 6-8.9h-3.8z"
          strokeWidth="0.6"
          strokeLinejoin="round"
          className="fill-primary-foreground stroke-primary-foreground"
        />
      </g>
    </svg>
  );
}

/** Logo + app name, as used in page headers. */
export function Brand({ className }: { className?: string }) {
  return (
    <span className={cn("flex items-center gap-2 text-sm font-bold tracking-wide", className)}>
      <Logo />
      {env.appName}
    </span>
  );
}
